import { render, staticRenderFns } from "./post-form.vue?vue&type=template&id=06a77c4b&scoped=true&"
import script from "./post-form.vue?vue&type=script&lang=js&"
export * from "./post-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a77c4b",
  null
  
)

export default component.exports